import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface VisionItem {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

const VisionCard: React.FC<VisionItem> = ({ number, title, description, icon: Icon }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 hover:transform hover:scale-105 transition-all duration-300">
      <div className="flex items-center gap-4 mb-4">
        <div className="bg-dark text-beige rounded-full w-10 h-10 flex items-center justify-center font-bold">
          {number}
        </div>
        <Icon className="h-6 w-6 text-dark" />
        <h3 className="text-xl font-bold text-dark">{title}</h3>
      </div>
      <p className="text-dark/80">{description}</p>
    </div>
  );
};

export default VisionCard;